module.exports = "https://trybtryb-legacy.web.app/img/to_bottom_left.4d621804.svg";